import React from "react";
import "./requestShiftBox.scss";

import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";

import { t } from "i18next";
import { Button, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";

const RequestShiftBox = ({
  id,
  name,
  surname,
  image,
  title,
  name_event,
  //start_datetime,
  //end_datetime,
  callback,
  linkDetailsShift,
  role,
}) => {
  return (
    <Stack className="shift-info-container" gap={4}>
      {/**Intestazione, info evento e turno */}
      <Stack gap={0}>
        <Stack
          direction="horizontal"
          className="d-flex justify-content-between align-items-center w-100"
        >
          <div>
            <span className="title-field-shift">
              {t("common.event").toUpperCase()}:
            </span>
            <span className="content-field-shift ms-1">{name_event}</span>
          </div>
          <a
            href={linkDetailsShift}
            className="more-details-link"
            style={{ color: "#03626E" }}
          >
            {t("common.more_details")}
          </a>
        </Stack>
        <div>
          <span className="title-field-shift">
            {t("common.shift").toUpperCase()}:{" "}
          </span>
          <span className="content-field-shift">{title}</span>
        </div>
        {/**ORARIO DI INIZIO E DI FINE */}
        {/*<div>
          <span className="title-field-shift">
            {t("common.times").toUpperCase()}:{" "}
          </span>
          <span className="content-field-shift">
            {start_datetime} - {end_datetime}
          </span>
        </div>*/}
      </Stack>

      {/**Immagine e info persona */}
      <Stack className="d-flex justify-content-center align-items-center">
        <img
          src={image}
          alt="Immagine profilo"
          className="image-profile-request-shift"
        />
        <span className="name-surname-request-shift">
          {name} {surname}
        </span>
        <span className="role-request-shift">{role?.toUpperCase()}</span>
      </Stack>

      {/**Bottone rifiuta ed accetta*/}
      <Stack
        direction="horizontal"
        gap={2}
        className="d-flex justify-content-end align-items-center"
      >
        <Button
          size="sm"
          variant="info"
          style={{ borderRadius: 10 }}
          onClick={(e) => {
            e.preventDefault();
            callback(id, false);
          }}
        >
          <Stack direction="horizontal" gap={1}>
            <span>{t("common.reject")}</span>
            <ClearIcon />
          </Stack>
        </Button>
        <Button
          size="sm"
          variant="success"
          style={{ borderRadius: 10 }}
          onClick={(e) => {
            e.preventDefault();
            callback(id, true);
          }}
        >
          <Stack direction="horizontal" gap={1}>
            <span>{t("common.accept")}</span>
            <CheckIcon />
          </Stack>
        </Button>
      </Stack>
    </Stack>
  );
};

export default RequestShiftBox;
